/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosPromise } from 'axios';
import api from './api';
import {
  EmplyeeFilter,
  AddEmployeeData,
  UpdatEmployeeData,
  Filters,
} from '../interfaces/employee';

const ConvertArrayFilterToObject = (filters: Filters = {}): EmplyeeFilter => {
  try {
    const object = filters.reduce(
      (obj: any, item: any) => ({ ...obj, ...item }),
      {},
    );
    return object;
  } catch (err) {
    return {};
  }
};

const SerializeFilters = (filters: any): string => {
  const str = [];
  for (const p in filters) {
    if (filters.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(filters[p])}`);
    }
  }
  return str.join('&');
};

class EmployeeService {
  getEmployee = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/employee/'
      : `api/pjtacom/employee/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  importExmployee = (data: any): AxiosPromise => {
    const headers = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    return api.post('api/pjtacom/employee/import/', data, headers);
  };

  getEmployeeId = (id: string): AxiosPromise => {
    return api.get(`api/pjtacom/employee/${id}/`);
  };

  deleteEmployee = (id: string): AxiosPromise => {
    return api.delete(`api/pjtacom/employee/${id}/`);
  };

  addEmployee = (data: AddEmployeeData): AxiosPromise => {
    return api.post('api/pjtacom/employee/', data);
  };

  updateEmployee = (data: UpdatEmployeeData): AxiosPromise => {
    return api.patch(`api/pjtacom/employee/${data.CodigoFuncionario}/`, data);
  };

  getFares = (): AxiosPromise => {
    return api.get('api/pjtacom/rates-lines/');
  };

  getEmployeeReport = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };

    const url = `api/pjtacom/report/employees?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  autoCardLink = (data: any): AxiosPromise => {
    return api.post('api/pjtacom/employee/link-card-auto/', data);
  };

  linkCardManual = (
    CodigoFuncionario: string,
    NumeroCartao: string,
  ): AxiosPromise => {
    return api.post('api/pjtacom/employee/link-card-manual/', {
      CodigoDoFuncionario: CodigoFuncionario,
      IdentificadorCartaoVT: NumeroCartao,
    });
  };
}

export default EmployeeService;
